//
//
//
//
//
//
//
//
//

export default {
  name: 'Example'
};